export default __webpack_public_path__ + "static/media/banner1.6b6a1f55.png";